import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  padding: 0;
  width: 100%;
  overflow-x: clip;
  overflow-y: visible;
  flex-direction: column;
`;

export const BodyContainer = styled.div`
  display: flex;
  padding: ${({ theme }) => theme.spaces.l}rem ${({ theme }) => theme.spaces.xxl}rem;
  flex-direction: column;

  @media (max-width: ${({ theme }) => theme.breakPoints.landscapeTablet *
    theme.percentBaseResponsive}rem) {
    padding: ${({ theme }) => theme.spaces.l}rem;
  }
`;
